import 'react-calendar/dist/Calendar.css';
import React from "react";
import Search from '../MainContent/Search/Search';
import Pagination from '../MainContent/Pagination/Pagination';
import RightSidebar from '../MainContent/RightSidebar/RightSidebar';
import Tabs from '../Tabs/Tabs';
import Marquee from '../Marquee/Marquee';
import ScrollToTops from '../ScrollToTop/ScrollToTop';


const MainContent = () => {
    return (
        <div>
            <div>

                {/* ---------------------------------------------------------------------------- */}
                <div class="container">
                    <div class="row g-5">
                        <div class="col-md-8">
                            {/* -------------------------------------    SEARCH--------------------------------------- */}
                            <Search />
                            <h3 class="pb-4 pt-4 mb-4  border-bottom">
                                Ахбор
                            </h3>
                            {/* --------------------------------------------- PAGINATION------------------------------------- */}

                            <Pagination itemsPerPage={8} />
                        </div>

                        {/* -----------------------------------------------   RIGHT SIDEBAR------------------------------------- */}
                        <div class="col-md-3 col-lg-4 col-xl-4 pt-5">
                            <div class="position-sticky" >
                                <RightSidebar />
                            </div>
                        </div>
                    </div>
                </div>
                {/* -----------------------------------------------TABS----------------------------------------------- */}

                <div className="container">
                    <Tabs />
                    <hr />
                </div>
                <div className="container">
                    {/* Marquee*/}

                    <Marquee />
                </div>
                {/* SCROLLTOTOPS*/}
            </div>
            <ScrollToTops />

        </div>
    );
}

export default MainContent;



